export default __webpack_public_path__ + "static/media/empty-place-avatar-large.06262773.jpg";